import clsx from 'clsx';
import { Variant } from 'components/CruiseSearchWidget/types';
import { AllFiltersList } from 'components/FiltersModal/AllFiltersList/AllFiltersList';
import { useFiltersModalContext } from 'components/FiltersModalProvider/FiltersModalProvider';
import { useFiltersContext } from 'components/FiltersProvider/FiltersProvider';
import { useMedia } from 'hooks/useMedia';
import { useEffect, useMemo } from 'react';
import { sizes } from 'styles/sizes';
import { ActiveFilter } from './ActiveFilter/ActiveFilter';
import { ActiveFilterHeader } from './ActiveFilterHeader/ActiveFilterHeader';
import { AllFiltersHeader } from './AllFiltersHeader/AllFiltersHeader';
import styles from './FiltersModal.css';
import { Footer } from './Footer/Footer';

export interface FiltersModalProps {
	variant: Variant;
	isPinned: boolean;
}

const variantToClass: { [key in Variant]: string } = {
	[Variant.Base]: styles.base,
	[Variant.Home]: styles.home,
};

export function FiltersModal({ variant, isPinned }: Readonly<FiltersModalProps>) {
	const { activeFilter, selection } = useFiltersContext();
	const { setShowFiltersModal } = useFiltersModalContext();
	const isDesktop = useMedia(`(min-width: ${sizes.desktop}px)`);

	const selectionCount = useMemo(() => Object.keys(selection).reduce((acum, key) => acum + selection[key].length, 0), [selection]);

	useEffect(() => {
		if (isDesktop && !activeFilter) {
			setShowFiltersModal(false);
		}
	}, [isDesktop, activeFilter, setShowFiltersModal]);

	return (
		<div className={clsx(styles.root, variantToClass[variant], { [styles.pinnedClass]: isPinned })} id="filters_modal">
			<div className={styles.content}>
				{activeFilter ? (
					<ActiveFilterHeader selectionCount={selectionCount} variant={variant} />
				) : (
					<AllFiltersHeader selectionCount={selectionCount} />
				)}
				{activeFilter ? <ActiveFilter variant={variant} selectionCount={selectionCount} /> : <AllFiltersList testId={'all_filter_list'} />}
			</div>
			<Footer />
		</div>
	);
}
